const { detect } = require('detect-browser');
const browser = detect();

// This is the plugin object. It can be exported to be used anywhere
const Creo = {

  // The install method is all that needs to exist on the plugin object
  // It takes the global Vue object as well as user-defined options
  install(Vue, options) {

    // Assign our prototype functionality into all components (this.$creo)
  	Vue.prototype.$creo = {

      // get browser pdf link depending on browser
      browserPdfLink(org, fallback, page) {
	      // if(browser){
		     //  var bName = browser.name;
	      //   if(bName === 'chrome' || bName === 'opera' || bName === 'firefox') {
	      //     return org + '#page=' + page;
	      //   }else{
	      //     return fallback;
	      //   }
	      // }else{
        	return fallback;
        // }
      },

      // get current language
      getLang() {
        // return 'sv';
        return 'sv';
        // return options.lang;
      }
    }

  }
};

export default Creo;
